import { render } from "./EventCard.vue?vue&type=template&id=e22c73ee&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=e22c73ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e22c73ee"

export default script